import type { ReactNode } from 'react'

import Icon from '@/legacy-src/components/icons/Icon'

import { Button, ButtonLink, type ButtonSharedProps } from '@/src/domains/design-system/components/Button'

export interface HeaderSupportButtonProps {
  href?: string
  onClick?: () => void
  icon: string
  children: ReactNode
}

export const HeaderSupportButton = ({ href, onClick, icon, children }: HeaderSupportButtonProps) => {
  const props: ButtonSharedProps = {
    variant: 'yellow',
    size: 'medium',
    prefixIcon: <Icon icon={icon} />,
  }

  const content = (
    <>
      {children}
      <Icon icon="arrow" color="primary" size="xs" className="ml-auto -rotate-45 laptop:ml-2" />
    </>
  )

  if (href) {
    return (
      <ButtonLink href={href} {...props} className="w-full">
        {content}
      </ButtonLink>
    )
  }

  return (
    <Button {...props} className="w-full" onClick={onClick}>
      {content}
    </Button>
  )
}
